////////////////////////////////////////////////////////////////////////////////
// Navigation
////////////////////////////////////////////////////////////////////////////////

class Navigation {

	constructor() {

		this.bar = $('navigation-bar')
		this.links = this.bar.find('a')

		let buttons      = this.bar.find('menu-block > button')
		let subMenus     = this.bar.find('menu-block > ul')
		let slogan       = this.bar.find('.slogan')
		let burgerButton = this.bar.find('button.menu')

		listen.for('naivgation-height', () => {
			CustomProperties.set('naivgation-height', (Math.round(this.bar.height()) || 83) + 'px' )
		});

		// Top Level Buttons -------------------------------------------------------

		buttons.on('click', e => {

			e.preventDefault()

			subMenus.css('height', '')

			let button = $(e.currentTarget)

			if (!button.hasClass('open')) {
				buttons.removeClass('open')
				button.addClass('open')

				let heights = 0;
				button.next().children().each((i, li) => {
					heights = heights + $(li).height()
				})

				button.next().css('height', heights)

			} else {

				button.removeClass('open')
				button.next().css('height', '')

				// Navigation.openCurrentSubmenu()
			}


		})

		// Sub Buttons -------------------------------------------------------------

		this.links.on('click', e => {
			let link = $(e.currentTarget)
			if ( link.parents('menu-block').length) {
			} else {
				buttons.removeClass('open')
				buttons.next().css('height', '')
			}
			this.links.removeClass('current')
			link.addClass('current')
		})

		// Slogan ------------------------------------------------------------------

		// if ( document.documentElement.dataset.localeId == "1" ) {
		// 	console.log('animating slogan')
		// 	let splitSlogan = new SplitText(slogan, { type:"lines, words, chars"} )
		// 	TweenMax.staggerFrom(splitSlogan.chars, 0.05, {
		// 		autoAlpha  : 0, delay : 4,
		// 		onStart    : function() { this.target.classList.add('in') },
		// 		onComplete : function() { this.target.classList.remove('in') },
		// 	}, 0.05, () => {
		// 		slogan.addClass('done')
		// 		// splitSlogan.revert()
		// 		if (typeof done == 'function') { done() }
		// 	})
		// }

		// Burger Menu Button ------------------------------------------------------

		burgerButton.on('click', event => {
			event.preventDefault()
			this.bar.toggleClass('show')
			body.toggleClass('locked')
		})

	}

	static openCurrentSubmenu() {

		// When the button is closed,  but another sub menu contains the current
		// page, then reopen the 'current' sub menu

		let current = $('navigation-bar menu-block ul li a.current')

		if ( current.length ) {
			let parent = current.parents('ul')
			let heights = 0
			parent.children().each((i, li) => {
				heights = heights + $(li).height()
			})
			parent.prev().addClass('open')
			parent.css('height', heights)
		}
	}

	static close() {
		$('navigation-bar.show').removeClass('show')
	}

	static update(slug) {

		if ( desktop ) {

			let links = $('navigation-bar a')
			let link = links.filter('[data-slug='+slug+']')

			links.removeClass('current')

			if ( link.length ) {
				let menuBlock = link.parents('menu-block')
				link.addClass('current')
			}

			Navigation.openCurrentSubmenu()

		}

	}

}
